var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reset"},[_c('div',{staticClass:"container"},[_c('ResetForm',{scopedSlots:_vm._u([{key:"before",fn:function(){return [_c('h3',{staticClass:"mt-m"},[_vm._v("Nieuw wachtwoord instellen")])]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }